'use client';
import e__default from 'react';
import { renderWithRef } from '../../core/render-with-ref.js';
import { RenderComp } from '../../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
const H3 = renderWithRef('H3', null, (t, o)=>{
    let { children: n } = t;
    return e__default.createElement(RenderComp, {
        root: "h3",
        forwardedRef: o,
        classNames: [
            'swan-heading'
        ],
        props: _object_spread({
            fontSize: 'x2large',
            fontWeight: 'bold'
        }, t)
    }, n);
});

export { H3 };
